import React from 'react';
import styled from 'styled-components';
import IconBrandReturn from '@tvg/fuse-icons/lib/BrandReturn';
import { Icon, Link, Divider, TypographyComponent as TypographyElement } from '@tvg/fuse-design';
import { NonReturnableInfoProps } from './NonReturnableInfoProps';

const RETURNABLE_CARD_TITLE = 'Returns Policy';

function NonReturnableInfo({ returnable }: NonReturnableInfoProps): JSX.Element {
  const { beforeLink, link } = returnable;

  const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: var(--spacing-space24);
  `;
  const HeadingContainer = styled.div`
    display: flex;
    align-items: center;
  `;
  const IconContainer = styled.div`
    flex: 0 0 var(--spacing-space32);
    position: relative;
    margin-right: var(--spacing-space8);
  `;
  const DividerContainer = styled.div`
    margin-top: var(--spacing-space24);
  `;

  return (
    <Container data-testid="non-returnable-wrapper">
      <HeadingContainer>
        <IconContainer>
          <Icon icon={<IconBrandReturn />} width="32px" height="32px" dataTestId="delivery-card-icon" />
        </IconContainer>
        <TypographyElement tag="h2" type="heading" size="1" data-testid="delivery-card-title">
          {RETURNABLE_CARD_TITLE}
        </TypographyElement>
      </HeadingContainer>
      <TypographyElement size="m1" tag="p" type="paragraph">
        {`${beforeLink} `}
      </TypographyElement>
      {link && (
        <Link href={link.href} data-testid="return-link" size="medium">
          {link.text}
        </Link>
      )}
      <DividerContainer>
        <Divider />
      </DividerContainer>
    </Container>
  );
}

export default NonReturnableInfo;
